"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectedOption = void 0;
function selectedOption(select) {
    if (select.selectedOptions) {
        // Modern browsers
        return select.selectedOptions[0];
    }
    else {
        // IE11
        return select.options[select.selectedIndex];
    }
}
exports.selectedOption = selectedOption;
